import React from 'react';

const CircleFlag = ({ countryCode, size = 24 }) => {
	return (
		<img
			src={`/assets/flags/${countryCode}.svg`}
			width={size}
			height={size}
			alt={countryCode}
			loading='lazy'
		/>
	);
};

export default CircleFlag;
